import Swiper, {Navigation, Pagination} from "swiper";

const CollectionSlider = (elements) => {
  if (elements.length < 1) return;

  elements.forEach(container => init(container));
  
  function init(container) {
    const mq = window.matchMedia('(min-width: 900px)');
    const swiperElement = container.querySelector('[data-swiper]');
    const nav = container.querySelector('[data-swiper-nav]');
    const navActions = Array.from(nav.querySelectorAll('.collection-slider__nav-action'));
    let swiper;

    toggleSwiper(mq.matches);
    setNavActiveItem(0);
    container.style.setProperty('--item-count', navActions.length);

    mq.addEventListener('change', () => {
      toggleSwiper(mq.matches);
    });

    navActions.forEach(action => action.addEventListener('click', e => {
      const action = e.target;
      const index = navActions.indexOf(action);
      setNavActiveItem(index);
      swiper.slideTo(index);
    }));

    function setNavActiveItem(index) {
      container.style.setProperty('--active-index', index);
    }

    function toggleSwiper(enable) {
      if (enable) {
        enableSwiper();
      } else {
        destroySwiper();
      }
    }

    function enableSwiper() {
      swiper = new Swiper(swiperElement, {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        spaceBetween: 64,
        centeredSlides: true,
        autoHeight: true,
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          prevEl: '.collection-slider__swiper-prev',
          nextEl: '.collection-slider__swiper-next',
        },
        on: {
          slideChange: function (swiper) {
            setNavActiveItem(swiper.activeIndex);
          },
        },
      });
    }

    function destroySwiper() {
      if (swiper !== undefined) {
        swiper.destroy(true, true);
      }
    }
  }
}

export default CollectionSlider;
